import React, { useState } from 'react';
import { Menu, X, ShoppingBag } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    document.querySelector(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const handleShopClick = () => {
    window.open('https://shop.brownishh.com', '_blank');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-warmCream/95 backdrop-blur-md border-b border-richBrown/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1 className="text-2xl font-bold text-richBrown tracking-tight">
              #Brownishh
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('#shop')}
              className="text-richBrown hover:text-goldAccent transition-colors duration-200 font-medium tracking-wide"
            >
              SHOP
            </button>
            <button 
              onClick={() => scrollToSection('#media')}
              className="text-richBrown hover:text-goldAccent transition-colors duration-200 font-medium tracking-wide"
            >
              MEDIA
            </button>
            <button 
              onClick={() => scrollToSection('#story')}
              className="text-richBrown hover:text-goldAccent transition-colors duration-200 font-medium tracking-wide"
            >
              OUR STORY
            </button>
            <ShoppingBag 
              onClick={handleShopClick}
              className="w-6 h-6 text-richBrown hover:text-goldAccent cursor-pointer transition-colors duration-200" 
            />
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-richBrown hover:text-goldAccent transition-colors duration-200"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-warmCream border-t border-richBrown/10">
              <button 
                onClick={() => scrollToSection('#shop')}
                className="block w-full text-left px-3 py-2 text-richBrown hover:text-goldAccent font-medium tracking-wide"
              >
                SHOP
              </button>
              <button 
                onClick={() => scrollToSection('#media')}
                className="block w-full text-left px-3 py-2 text-richBrown hover:text-goldAccent font-medium tracking-wide"
              >
                MEDIA
              </button>
              <button 
                onClick={() => scrollToSection('#story')}
                className="block w-full text-left px-3 py-2 text-richBrown hover:text-goldAccent font-medium tracking-wide"
              >
                OUR STORY
              </button>
              <button 
                onClick={handleShopClick}
                className="block w-full text-left px-3 py-2 text-richBrown hover:text-goldAccent font-medium tracking-wide"
              >
                🛍️ SHOP NOW
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;